$(function(){
        $('.js-sp-menu').on('click', function(){           
            if($(this).hasClass('is-open')) {
                $(this).removeClass('is-open');
                $(this).next().slideUp();
                $(".brand-menu-overlay").fadeOut();
            } else {
                $(this).addClass('is-open');
                $(this).next().slideDown();
              	$(".brand-menu-overlay").fadeIn();
            }
        });
  		$('.brand-menu-overlay').on('click', function(){ 
            $('.js-sp-menu').removeClass('is-open');
            $('.js-sp-menu').next().slideUp();
            $(this).fadeOut();
        });
});
